import T from "utils/constants/T";
import { useEffect, useMemo, useReducer } from "react";
import { Box, Tabs, Tab, styled } from "@mui/material";
import { IdcardOutlined } from '@ant-design/icons';
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import MainCard from "components/MainCard";
import { get } from "lodash";
import { useSelector } from 'store';
import CompanyIcon from "assets/images/icons/company";
import FinancialSettingsIcon from "assets/images/icons/financialSettingIcon";
import PayrollSettingsIcon from "assets/images/icons/payrollSettingsIcon";
import BankingSettingsIcon from "assets/images/icons/bankingSettingsIcon";
import WhitelabellingSettingIcon from "assets/images/icons/whitelabellingSettingsIcon";
import EmailSettingsIcon from "assets/images/icons/emailSettingsIcon";
import KeyIcon from '@mui/icons-material/Key';

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "capitalize",
  fontWeight: 700,
  fontSize: "16px",
  alignItems: "center",
  justifyContent: "flex-start",
  color: "black",
  minHeight: "unset",
  backgroundColor: "white"
}));

const CompanyDetailsPage = () => {
  let { selectedCompany } = useSelector(state => state.dashboardSearch);
  const { isManagerAdmin, isPayrollOfficer } = useSelector((state: any) => state.auth);
  const selectedCompanyId = get(selectedCompany, "_id", "");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const selectedTab = useMemo(() => {
    const tabMapping: Record<string, number> = {
      "/companyDetails/DeveloperAccountSetting/view": 7,
      "/companyDetails/emailSettings/view": 6,
      "/companyDetails/emailSettings/edit": 6,
      "/companyDetails/whiteLabelling/view": 5,
      "/companyDetails/whiteLabelling/edit": 5,
      "/companyDetails/bankingSettings/view": 4,
      "/companyDetails/bankingSettings/edit": 4,
      "/companyDetails/payrollSettings/view": 3,
      "/companyDetails/payrollSettings/edit": 3,
      "/companyDetails/financialSettings/view": 2,
      "/companyDetails/financialSettings/edit": 2,
      "/companyDetails/kyb/view": 1,
      "/companyDetails/kyb/edit": 1,
      "/companyDetails/company/edit": 0,
      "/companyDetails/company/view": 0,
    };
  
    return tabMapping[pathname] ?? 0;
  }, [pathname]);

  const [localState, setLocalState] = useReducer(
    (prevState: any, newState: any) => ({ ...prevState, ...newState }),
    {
      value: selectedTab,
    }
  );

  const {
    value,
  } = localState;

  useEffect(() => {
    navigate('/companyDetails/company/view');
    if (pathname === '/companyDetails/company/view') {
      setLocalState({
        value: 0
      });
    }
  }, [selectedCompanyId])

  const handleTabChange = (event: any, newValue: number) => {
    setLocalState({
      value: newValue
    });
  };

  useEffect(() => {
  setLocalState({ value: selectedTab });
}, [selectedTab,selectedCompanyId]);

  return (

    <MainCard pageHeading={T.SETTINGS} border={false} boxShadow>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', backgroundColor: "white" }}>
        <Tabs value={value} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="account profile tab">

          <Tab icon={<CompanyIcon />} iconPosition="start" component={Link} to="/companyDetails/company/view" label={T.COMPANY} />
          <Tab icon={<IdcardOutlined />} iconPosition="start" component={Link} to="/companyDetails/kyb/view" label={T.KYB} />
          <Tab icon={<FinancialSettingsIcon />} iconPosition="start" component={Link} to="/companyDetails/financialSettings/view" label={T.FINANCIAL} />
          <Tab icon={<PayrollSettingsIcon />} iconPosition="start" component={Link} to="/companyDetails/payrollSettings/view" label={T.PAYROLL} />
          <Tab icon={<BankingSettingsIcon />} iconPosition="start" component={Link} to="/companyDetails/bankingSettings/view" label={T.BANKING} />
          <Tab icon={<WhitelabellingSettingIcon /> }  iconPosition="start" component ={Link} to="/companyDetails/whiteLabelling/view" label={T.BRAND} />
          <Tab icon={<EmailSettingsIcon /> }  iconPosition="start" component ={Link} to="/companyDetails/emailSettings/view" label={T.EMAIL} />
          {!isManagerAdmin && !isPayrollOfficer && (
            <Tab icon={<KeyIcon /> }  iconPosition="start" component ={Link} to="/companyDetails/DeveloperAccountSetting/view" label={T.API_KEY} />
          )}
        </Tabs>
      </Box>
      <Box
        sx={{
          "& .MuiTabPanel-root": {
            p: 2,
            pt: 0,
          },
        }}
      >
        <Outlet />
      </Box>
    </MainCard>
  );
};

export default CompanyDetailsPage;